import { useState, useRef, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css"; // Import Bootstrap Icons
import PopUpMenu from "./ManageUserExport";
import vec from "./../../../assets/images/calender/Vector.png";
import "./../style/customDropdown.css";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { LocalStorage } from "../../../utils/Utils";
import Logger from "../../../utils/Logger";

interface CustomDropdownProps {
  onSelectionChange: (
    selectedValues: { program_title: string; program_id: string }[],
  ) => void;
}
const CustomDropdown: React.FC<CustomDropdownProps> = ({
  onSelectionChange,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // State for the Select dropdown
  const [selectMenuVisible, setSelectMenuVisible] = useState(false);
  const [selectMenuPosition, setSelectMenuPosition] = useState({ x: 0, y: 0 });

  // State for the Add dropdown
  const [addMenuVisible, setAddMenuVisible] = useState(false);
  const [addMenuPosition, setAddMenuPosition] = useState({ x: 0, y: 0 });

  const [selectedValues, setSelectedValues] = useState<
    { program_title: string; program_id: string }[]
  >([]);
  const [checkboxStates, setCheckboxStates] = useState<Record<string, boolean>>(
    {},
  ); // Define checkboxStates with appropriate type
  const [isAllSelected, setIsAllSelected] = useState(false);

  const selectButtonRef = useRef<HTMLButtonElement>(null); // Ref for the Select button
  const dropdownRef = useRef<HTMLDivElement>(null);
  const addButtonRef = useRef<HTMLButtonElement>(null); // Ref for the Add button
  const listProgramData = useSelector(
    (state: RootState) => state.programs.programs,
  );
  const handleSelectClick = () => {
    // Toggle the visibility of the Select dropdown
    setSelectMenuVisible(!selectMenuVisible);

    // Calculate the position to display the menu below the button
    if (selectButtonRef.current) {
      const { top, left, height } =
        selectButtonRef.current.getBoundingClientRect();
      setSelectMenuPosition({ x: left, y: top + height + window.scrollY }); // Set x and y
    }
  };

  const handleAddClick = () => {
    // Toggle the visibility of the Add dropdown
    setAddMenuVisible(!addMenuVisible);

    // Calculate the position to display the menu below the button
    if (addButtonRef.current) {
      const { top, left, height } =
        addButtonRef.current.getBoundingClientRect();
      setAddMenuPosition({
        x: left - 40,
        y: top + height + window.scrollY - 4,
      }); // Set x and y
    }
  };

  const handleSelectClose = () => {
    setSelectMenuVisible(false);
  };

  const handleAddClose = () => {
    setAddMenuVisible(false);
  };

  const handleCheckboxChange = (program_title: string) => {
    if (program_title === "All Programs") {
      const newCheckboxStates: { [key: string]: boolean } = {
        "All Programs": !isAllSelected,
      };
      listProgramData.forEach((program) => {
        newCheckboxStates[program.program_title] = false;
      });
      setCheckboxStates(newCheckboxStates);
      setIsAllSelected(!isAllSelected);
    } else {
      const newCheckboxStates = {
        ...checkboxStates,
        [program_title]: !checkboxStates[program_title],
      };
      newCheckboxStates["All Programs"] = false;
      setCheckboxStates(newCheckboxStates);
      setIsAllSelected(false);
    }
  };

  const handleSelect = () => {
    if (isAllSelected) {
      setSelectedValues([{ program_title: "All Programs", program_id: "all" }]);
      LocalStorage.setLocalData("selected", "All Programs");
      onSelectionChange([{ program_title: "All Programs", program_id: "all" }]);
    } else {
      const selected = Object.keys(checkboxStates)
        .filter((key) => checkboxStates[key])
        .map((program_title) => {
          const program = listProgramData.find(
            (p) => p.program_title === program_title,
          );
          return { program_title, program_id: program?.program_id || "" };
        });
      setSelectedValues(selected);
      const selectedTitles = selected
        .map((item) => item.program_title)
        .join(", ");
      LocalStorage.setLocalData("selected", selectedTitles);
      onSelectionChange(selected);
    }
    setSelectMenuVisible(false);
  };
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        !selectButtonRef.current?.contains(event.target as Node)
      ) {
        setSelectMenuVisible(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div>
      <Row
        className=" d-flex justify-content-between"
        style={{
          paddingLeft: "0px",
          paddingRight: "0px",
          display: "flex",
          justifyContent: "space-between",
          margin: "0px",
        }}
      >
        <Col
          md="auto"
          className="d-flex dropdown_col"
          style={{
            paddingLeft: "0px",
            marginLeft: "auto",
            justifyContent: "flex-end",
          }}
        >
          <Button
            ref={selectButtonRef}
            variant="light"
            id="dropdown-basic"
            onClick={handleSelectClick}
            className="dropDown_button"
            style={{
              backgroundColor: "#E7EFFF",
              color: "#4D7CE0",
              border: "none",
              padding: "8px 8px",
              minWidth: "50px",
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontFamily: "Mazzard",
                color: "#4D7CE0",
                fontWeight: "400",
              }}
            >
              Change Program
            </span>
            <i
              className="bi bi-chevron-down ms-1"
              style={{ color: "#4D7CE0" }}
            ></i>
          </Button>

          {/* Select Dropdown Menu */}
          {selectMenuVisible && (
            <div
              ref={dropdownRef}
              style={{
                position: "absolute",
                top: `${selectMenuPosition.y}px`,
                // left: `${selectMenuPosition.x}px`,
                padding: "15px",
                backgroundColor: "#FFFFFF",
                borderRadius: "6px",
                border: "1px solid rgba(208, 213, 221, 1)",
                zIndex: 1050,
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              }}
            >
              <Form>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    marginBottom: "10px",
                    color: "#242730",
                    width: "10vw",
                    maxWidth: "10vw",
                  }}
                >
                  {listProgramData.length !== 0 ? (
                    <Form.Check
                      type="checkbox"
                      label="All Programs"
                      onChange={() => handleCheckboxChange("All Programs")}
                      checked={isAllSelected}
                      style={{ margin: "0" }}
                      className="custom-checkbox-label"
                    />
                  ) : (
                    "No Programs Found"
                  )}
                </div>

                {listProgramData.map((program) => (
                  <div
                    key={program.program_id}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                      marginBottom: "10px",
                      color: "#242730",
                    }}
                  >
                    <Form.Check
                      type="checkbox"
                      label={program.program_title}
                      onChange={() =>
                        handleCheckboxChange(program.program_title)
                      }
                      checked={checkboxStates[program.program_title] || false}
                      style={{ margin: "0" }}
                      className="custom-checkbox-label"
                    />
                  </div>
                ))}

                {listProgramData.length > 0 && (
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <button
                      className="mt-3 select-button"
                      onClick={handleSelect}
                      disabled={Object.values(checkboxStates).every(
                        (state) => !state,
                      )}
                    >
                      Select
                    </button>
                  </div>
                )}
              </Form>
            </div>
          )}
        </Col>

        <Col md="auto" className="d-flex justify-content-end">
          {/* Add Popover Menu */}
          {addMenuVisible && (
            <PopUpMenu
              labels={["Create Program", "Associate Event"]}
              callBacks={[
                () => navigate("/createprogram"),
                () => Logger.info("Associate Event"),
              ]}
              position={addMenuPosition} // Using x and y for the position
              onClose={handleAddClose}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CustomDropdown;
